import { Typography, TypographyProps } from "@mui/material";
import * as React from "react";

interface IProps {
    component?: React.ElementType;
    noWrapRows?: number;
    textColor?: MprcColors;
    textColorVariant?: MprcColorVariant;
    reverse?: boolean;
}

export type MprcTypographyProps = IProps & TypographyProps;

export const MprcTypography: React.FC<MprcTypographyProps> = (props) => {
    const { children, textColor, textColorVariant, reverse = false, noWrapRows, component, sx, ...rest } = props;

    const wrapRowsStyle = noWrapRows == undefined ? {} : {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: noWrapRows,
        WebkitBoxOrient: 'vertical',
        lineHeight: 1.2
    }

    const styleSx = sx == undefined ? {} : Array.isArray(sx) ? sx : [sx];

    return (
        <Typography
            component={component ?? "div"}
            {...rest}
            sx={theme => ({
                color: reverse ? theme.palette.getContrastText(theme.palette[textColor!]) : textColor && textColorVariant ? theme.palette[textColor!][textColorVariant!] : rest.color,
                backgroundColor: reverse ? theme.palette[textColor!][textColorVariant!] : "inherit",
                ...wrapRowsStyle,
                ...styleSx,
            })}
        >
            {children}
        </Typography>
    );
};
